<template>
  <div class="lines flex flex-row gap-x-1 w-full">
    <div v-for="index in steps" :key="index" class="step" :class="{ current: step >= index }" />
  </div>
</template>

<script>
export default {
  name: 'StepLines',
  props: {
    steps: Number,
    step: Number,
  },
};
</script>

<style lang="scss" scoped>
// The design spans the lines across exactly the width of the Continue button
// below/above them, then divides that evenly - so the count drives the line
// width, not the other way round. 246px is CButton's own max-width.
.lines {
  max-width: 246px;
  margin-left: auto;
  margin-right: auto;
}

.step {
  flex: 1 1 0;
  min-width: 0;
  height: 4px;
  background: #d9d9d9;
  border-radius: 17px;

  &.current {
    background: #3630f8;
  }
}
</style>
